<template>
  <div class="mt-3">
    <v-card class="mb-3">
      <v-card-title class="headline pb-0">Yatri Refund</v-card-title>
      <v-card-text>
        <v-layout row wrap align-center>
          <v-flex xs12 md6 lg5>
            <v-text-field
              v-model="search"
              label="Search"
              placeholder="Transaction ID, Mobile, User ID, Reference No, Payment Transaction ID"
              solo
              flat
              clearable
              hide-details
              @keyup.enter="searchRefunds"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 lg3>
            <v-btn color="primary" class="ml-2" :loading="loaders.list" @click="searchRefunds">
              <v-icon left>search</v-icon>
              Search
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <h4 class="mb-2">Total {{ total_items }}</h4>

    <v-data-table
      :headers="headers"
      :items="refund_list"
      :pagination.sync="pagination"
      :loading="loaders.list"
      :rows-per-page-items="[10, 20, 50, 100]"
      no-results-text="No refund records found"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ refund_list.indexOf(props.item) + 1 }}</td>
        <td>{{ props.item.transaction_id || "-" }}</td>
        <td>{{ props.item.user_name || "-" }}</td>
        <td>{{ props.item.mobile || "-" }}</td>
        <td>{{ props.item.ticket_status || "-" }}</td>
        <td>{{ props.item.payment_type || "-" }}</td>
        <td>{{ props.item.payment_status || "-" }}</td>
        <td>{{ formatPrice(props.item.price) }}</td>
        <td>{{ formatPrice(props.item.discounted_amount) }}</td>
        <td>{{ props.item.payment_provider || "-" }}</td>
        <td>{{ props.item.provider_name || "-" }}</td>
        <!-- <td>{{ props.item.descriptor_name || "-" }}</td> -->
        <td>{{ props.item.start_stop_name || "-" }}</td>
        <td>{{ props.item.end_stop_name || "-" }}</td>
        <td>{{ props.item.action || "-" }}</td>
        <td>{{ props.item.pg_refund_status || "-" }}</td>
        <td>{{ props.item.refund_amount || "-" }}</td>
        <td>{{ props.item.created_at || "-" }}</td>
        <td>
          <v-btn
            v-if="isRefundProcessed(props.item)"
            small
            color="success"
            depressed
            disabled
            class="white--text"
          >
            <v-icon left small color="white">check_circle</v-icon>
            Refunded
          </v-btn>
          <v-btn v-else small color="primary" @click="openRefundDialog(props.item)">
            Issue Refund
          </v-btn>
        </td>
      </template>

      <template v-slot:no-data>
        <v-layout v-if="loaders.list" justify-center>Loading... Please wait</v-layout>
        <v-layout v-else justify-center>
          {{ searched ? "No refund records found" : "Search to view refund details" }}
        </v-layout>
      </template>
    </v-data-table>

    <v-dialog v-model="refundDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">Submit Refund</v-card-title>
        <v-card-text>
          <div class="mb-3">
            <strong>Transaction ID:</strong> {{ selectedRefund.transaction_id || "-" }}
          </div>
          <div class="mb-3">
            <strong>Price:</strong> {{ formatPrice(selectedRefund.price) }}
          </div>
          <v-text-field
            v-model="refundForm.refund_amount"
            label="Refund Amount"
            type="number"
            box
            :error-messages="refundErrors.refund_amount"
          ></v-text-field>
          <v-textarea
            v-model="refundForm.refund_message"
            label="Refund Message"
            box
            rows="3"
            required
            :error-messages="refundErrors.refund_message"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat :disabled="loaders.submit" @click="refundDialog = false">Cancel</v-btn>
          <v-btn color="primary" :loading="loaders.submit" @click="submitRefund">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :color="snackBar.color"
      :top="snackBar.top"
      :right="snackBar.right"
      v-model="snackBar.show"
      :timeout="2500"
    >
      {{ snackBar.message }}
      <v-btn dark flat @click.native="snackBar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      searched: false,
      refund_list: [],
      total_items: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "created_at",
        descending: true,
      },
      loaders: {
        list: false,
        submit: false,
      },
      snackBar: {
        show: false,
        message: "",
        color: "black",
        top: true,
        right: true,
      },
      refundDialog: false,
      selectedRefund: {},
      refundForm: {
        refund_amount: "",
        refund_message: "",
      },
      refundErrors: {
        refund_amount: [],
        refund_message: [],
      },
      headers: [
        { text: "Sr No", value: "sr_no", sortable: false },
        { text: "Transaction ID", value: "transaction_id", sortable: false },
        { text: "User", value: "user_name", sortable: false },
        { text: "Mobile", value: "mobile", sortable: false },
        { text: "Ticket Status", value: "ticket_status", sortable: false },
        { text: "Payment Type", value: "payment_type", sortable: false },
        { text: "Payment Status", value: "payment_status", sortable: false },
        { text: "Price", value: "price", sortable: false },
        { text: "Discount", value: "discounted_amount", sortable: false },
        { text: "Payment Provider", value: "payment_provider", sortable: false },
        { text: "Provider", value: "provider_name", sortable: false },
        // { text: "Descriptor", value: "descriptor_name" },
        { text: "Source", value: "start_stop_name", sortable: false },
        { text: "Destination", value: "end_stop_name", sortable: false },
        { text: "Settlement Status", value: "action", sortable: false },
        { text: "Refund Status", value: "pg_refund_status", sortable: false },
        { text: "Refund Amount", value: "refund_amount", sortable: false },
        { text: "Created At", value: "created_at" },
        { text: "Action", value: "action_btn", sortable: false },
      ],
    };
  },

  mounted() {
    this.getRefundList();
  },

  methods: {
    searchRefunds() {
      this.pagination.page = 1;
      this.getRefundList();
    },

    formatPrice(value) {
      if (value === null || value === undefined || value === "") return "-";
      return value;
    },

    isRefundProcessed(item) {
      const refundAmount = Number(item && item.refund_amount);
      const status = (item && item.pg_refund_status) ? String(item.pg_refund_status).trim().toLowerCase() : "";

      return item &&
        refundAmount !== 0 &&
        !Number.isNaN(refundAmount) &&
        status === "processed";
    },

    openRefundDialog(item) {
      this.selectedRefund = item || {};

      const price = Number(item.price) || 0;
      const discountedAmount = Number(item.discounted_amount) || 0;

      const refundAmount =
        item.discounted_amount !== null &&
        item.discounted_amount !== undefined &&
        item.discounted_amount !== ""
          ? price - discountedAmount
          : price;

      this.refundForm = {
        refund_amount: refundAmount,
        refund_message: "",
      };

      this.refundErrors = {
        refund_amount: [],
        refund_message: [],
      };

      this.refundDialog = true;
    },

    submitRefund() {
      this.refundErrors = {
        refund_amount: [],
        refund_message: [],
      };

      const amount = this.refundForm.refund_amount;
      const price = Number(this.selectedRefund.price) || 0;

      const discountedAmount =
        this.selectedRefund.discounted_amount !== null &&
        this.selectedRefund.discounted_amount !== undefined &&
        this.selectedRefund.discounted_amount !== ""
          ? Number(this.selectedRefund.discounted_amount) || 0
          : 0;

      const maxRefundAmount =
        this.selectedRefund.discounted_amount !== null &&
        this.selectedRefund.discounted_amount !== undefined &&
        this.selectedRefund.discounted_amount !== ""
          ? price - discountedAmount
          : price;

      if (Number(amount) > maxRefundAmount) {
        this.snackBar.message =
          `Refund amount cannot be greater than ${maxRefundAmount}`;
        this.snackBar.color = "error";
        this.snackBar.show = true;
        return;
      }

      if (
        amount === "" ||
        amount === null ||
        amount === undefined ||
        Number.isNaN(Number(amount))
      ) {
        this.refundErrors.refund_amount = ["Refund amount is required"];
        return;
      }

      if (!this.refundForm.refund_message || !this.refundForm.refund_message.trim()) {
        this.refundErrors.refund_message = ["Refund message is required"];
        return;
      }

      // Check if refund amount exceeds the ticket price
      if (Number(amount) > price) {
          this.snackBar.message = `Refund amount cannot be greater than the price (${price})`;
          this.snackBar.color = "error";
          this.snackBar.show = true;
        return;
      }

      if (!this.selectedRefund.transaction_id) {
        this.snackBar.message = "Transaction ID not found";
        this.snackBar.color = "error";
        this.snackBar.show = true;
        return;
      }

      this.loaders.submit = true;

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v4/issue-refund`,
          {
            transaction_id: this.selectedRefund.transaction_id,
            refund_amount: amount ? Number(amount) : null,
            refund_message: this.refundForm.refund_message.trim(),
            refund_for: "metro"
          },
          { headers: this.$headers }
        )
        .then((response) => {
          const payload = response.data || {};
          if (payload.status === true || payload.status === 1) {
            this.snackBar.message = payload.message || "Refund issued successfully";
            this.snackBar.color = "success";
            this.snackBar.show = true;
            this.refundDialog = false;
            this.getRefundList();
          } else {
            this.snackBar.message = payload.message || "Failed to issue refund";
            this.snackBar.color = "error";
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          const payload = error.response && error.response.data;
          const errors = payload && payload.errors;
          if (errors) {
            this.refundErrors.refund_amount = errors.refund_amount || [];
            this.refundErrors.refund_message = errors.refund_message || [];
          }
          this.snackBar.message = (payload && payload.message) || "Failed to issue refund";
          this.snackBar.color = "error";
          this.snackBar.show = true;
        })
        .finally(() => {
          this.loaders.submit = false;
        });
    },

    getRefundList() {
      this.loaders.list = true;
      this.searched = true;

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v4/get-refund-list`,
          { search: (this.search || "").trim() },
          { headers: this.$headers }
        )
        .then((response) => {
          const payload = response.data || {};
          const list = Array.isArray(payload.data) ? payload.data : [];
          this.refund_list = list;
          this.total_items = list.length;

          if (payload.status !== true && payload.status !== 1) {
            this.snackBar.message = payload.message || "Data not found";
            this.snackBar.color = "black";
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          const payload = error.response && error.response.data;
          this.refund_list = [];
          this.total_items = 0;

          if (error.response && error.response.status === 404) {
            this.snackBar.message = (payload && payload.message) || "Data not found";
            this.snackBar.color = "black";
          } else {
            this.snackBar.message = "Something went wrong";
            this.snackBar.color = "error";
          }
          this.snackBar.show = true;
        })
        .finally(() => {
          this.loaders.list = false;
        });
    },

    isRefundProcessed(refund) {
      return refund.pg_refund_status === 'processed';
    },
  },
};
</script>
